import L from 'leaflet'

export default function createGeoObject() {

  const ops = { permanent: false, direction:"center", className: 'bindTooltipStyle'}

  const newGeoObj = (g, c) => {

    const area = g.area
    const att = g.attributes
    const type = area.slice(0,1)
    const options = { weight: 0, fillColor: 'red', fillOpacity: 0.3, opacity: 0.4, color: 'red', c: c}

    switch(type) {
      case 'C':
        const { latLng, r } = ExtractCircleData(area)
        return L.circle([parseFloat(latLng[0]), parseFloat(latLng[1])], {...options,  radius: r})
          .bindTooltip(`<div style="background: white;font-size:0.7rem;padding:1px; !important;">${g.name}</div>`, ops).openTooltip()
      case 'P':
        const points = area.split('((')[1].slice(0, -2).split(', ')
        return L.polygon(points.map((v, i) => [
          parseFloat(v.split(' ')[0]), parseFloat(v.split(' ')[1])]),options)
          .bindTooltip(`<div class="g_name" style="background: white;font-size:0.7rem; padding:1px; !important; ">${g.name}</div>`, ops).openTooltip()
      case 'L':
        const linePoints = area.split('(')[1].slice(0, -1).split(', ')
        return L.polyline(linePoints.map((v, i) => [
          parseFloat(v.split(' ')[0]), parseFloat(v.split(' ')[1])]), options)
          .bindTooltip(`<div style="background: white;font-size:0.7rem;padding:1px; !important;">${g.name}</div>`, ops).openTooltip()
    }
  }

  const ExtractCircleData = (area) => {
    const points = ((area.split('(')[1]).slice(0, -1)).split(', ')
    const latLng = points[0].split(' ')
    const r = points[1]

    return {
      latLng, r
    }
  }


  return {
    newGeoObj
  }
}